import {
    Button,
    Flexer,
    Footer,
    Input,
    InputControl,
    InputPrefix,
    Label,
    Stack,
    Textarea,
    useInput,
} from '@fold-dev/core'
import { useEffect, useState } from 'react'
import { COLORS } from '../../constants'
import { ColorButton } from '../common'

export const TodoSectionEdit = (props) => {
    const { onUpdate, onBack } = props
    const title = useInput(props.title)
    const description = useInput(props.description)
    const [color, setColor] = useState(props.color)

    const handleCreate = () => {
        onUpdate({
            title: title.value,
            description: description.value,
            color: color,
        })
    }

    return (
        <div>
            <Stack
                p="1rem"
                width="100%"
                direction="vertical"
                spacing="0.75rem">
                <InputControl>
                    <InputPrefix>
                        <ColorButton
                            color={color}
                            onChange={setColor}
                            colors={COLORS}
                        />
                    </InputPrefix>
                    <Input
                        autoFocus
                        selectOnFocus
                        placeholder="Growth Plan"
                        value={title.value}
                        onChange={title.onChange}
                    />
                </InputControl>
                <Textarea
                    autoAdjust
                    selectOnFocus
                    value={description.value}
                    minHeight={100}
                    placeholder="Section description"
                    onChange={description.onChange}
                />
            </Stack>

            <Footer
                p="0.5rem"
                bg="transparent">
                <Button
                    size="sm"
                    onClick={onBack}>
                    Back
                </Button>
                <Flexer />
                <Button
                    onClick={handleCreate}
                    variant="accent"
                    size="sm"
                    disabled={!title.value}>
                    Save
                </Button>
            </Footer>
        </div>
    )
}
